import { styled, css } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const ProductGrid = styled.div<{ $maxColumns?: 3 | 4 }>`
  display: grid;
  grid-gap: ${(props) => props.theme.spacing.m};

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    grid-template-columns: repeat(3, 1fr);
  }

  ${(props) =>
    props.$maxColumns === 4 &&
    css`
      @media (min-width: 1150px) {
        grid-template-columns: repeat(4, 1fr);
      }
    `}
`;
